import { initializePopovers } from "../utils";
import { showReturnNotification } from "./dashboard_utils";
// Domain management functionality
export function setupDomainManagement() {
    // Check if we have domains to display
    const noDomainView = document.getHtmlElementById("noDomainView");
    const domainsTableView = document.getHtmlElementById("domainsTableView");
    const domainsTableBody = document.getHtmlElementById("domainsTableBody");
    if (noDomainView && domainsTableView) {
        if (domainsTableBody && domainsTableBody.children.length > 0) {
            // Show the domains table and hide the empty state
            noDomainView.bootstrapHide();
            domainsTableView.bootstrapShow();
        }
        else {
            // Show the empty state and hide the domains table
            noDomainView.bootstrapShow();
            domainsTableView.bootstrapHide();
        }
    }
    // Set up domain search functionality
    setupDomainSearch();
    // Set up domain removal functionality
    setupDomainRemoval();
}
// Handle domain search functionality with slide animation
function setupDomainSearch() {
    const searchButtons = document.queryHtmlElements(".domain-search-btn");
    const domainListView = document.getHtmlElementById("domainListView");
    const domainSearchView = document.getHtmlElementById("domainSearchView");
    const searchDomainTitle = document.getHtmlElementById("searchDomainTitle");
    const domainSearchBackBtn = document.getHtmlElementById("domainSearchBackBtn");
    const domainSearchResults = document.getHtmlElementById("domainSearchResults");
    const searchFilter = document.getHtmlElementById("domainSearchFilter");
    const searchBreachFilter = document.getHtmlElementById("domainSearchBreachFilter");
    const domainLoading = document.getHtmlElementById("domainLoading");
    const domainSearchResultsFound = document.getHtmlElementById("domainSearchResultsFound");
    const noBreachedAddressesOnDomain = document.getHtmlElementById("noBreachedAddressesOnDomain");
    const domainSearchTable = document.getHtmlElementById("domainSearchTable");
    const insufficientSubscriptionWarning = document.getHtmlElementById("insufficientSubscription");
    const maxDomainSize = document.getElementById("Domains")?.getAttribute("data-max-domain-size");
    let thisDomainSize = 0;
    // Initialize popovers and tooltips for the domain search view
    initializePopovers();
    if (!searchButtons.length || !domainListView || !domainSearchView) {
        return; // Required elements not found
    }
    // Add event listeners to search buttons
    for (const button of searchButtons) {
        button.addEventListener("click", async function () {
            const domain = this.dataset.domain ?? "";
            const apiToken = this.dataset.apiToken ?? "";
            await showDomainSearchResults(domain, apiToken);
        });
    }
    // Back button functionality
    if (domainSearchBackBtn) {
        domainSearchBackBtn.addEventListener("click", hideDomainSearchResults);
    }
    // Filter functionality
    if (searchFilter) {
        searchFilter.addEventListener("input", function () {
            filterDomainSearchResults(this.value);
        });
    }
    // Breach filter functionality
    if (searchBreachFilter) {
        searchBreachFilter.addEventListener("change", function () {
            sortDomainSearchResults(this.value);
        });
    }
    // Function to show domain search results with animation
    async function showDomainSearchResults(domain, apiToken) {
        // Update the domain title
        if (searchDomainTitle) {
            searchDomainTitle.textContent = domain || "";
        }
        const downloadJsonButton = document.getHtmlElementById("domainSearchJsonBtn");
        if (downloadJsonButton?.dataset.downloadLink) {
            downloadJsonButton.addEventListener("click", () => {
                window.open(downloadJsonButton.dataset.downloadLink?.replace("**DOMAIN**", encodeURIComponent(domain)) ?? "", "_blank");
            });
        }
        const downloadExcelButton = document.getHtmlElementById("domainSearchExcelBtn");
        if (downloadExcelButton?.dataset.downloadLink) {
            downloadExcelButton.addEventListener("click", () => {
                window.open(downloadExcelButton.dataset.downloadLink?.replace("**DOMAIN**", encodeURIComponent(domain)) ?? "", "_self");
            });
        }
        // Update domain stats in the summary cards
        updateDomainSummaryStats(domain);
        // Clear previous results and reset the display
        if (domainSearchResults) {
            domainSearchResults.innerHTML = "";
        }
        if (domainSearchResultsFound) {
            domainSearchResultsFound.bootstrapHide();
        }
        if (domainSearchTable) {
            domainSearchTable.bootstrapShow();
        }
        if (noBreachedAddressesOnDomain) {
            noBreachedAddressesOnDomain.bootstrapHide();
        }
        if (insufficientSubscriptionWarning) {
            insufficientSubscriptionWarning.bootstrapHide();
        }
        if (searchBreachFilter) {
            searchBreachFilter.selectedIndex = 0;
        }
        // Initialize popovers for the domain summary cards
        initializePopovers();
        // First fade out domain list view
        if (domainListView) {
            domainListView.style.opacity = "0";
        }
        // Hide domain list and show search view
        domainListView?.classList.add("slide-left");
        domainSearchView?.classList.add("slide-left");
        // Fade in search view
        if (domainSearchView) {
            domainSearchView.style.opacity = "1";
        }
        if (domainLoading && domainSearchResultsFound) {
            domainLoading.bootstrapShow();
            domainSearchResultsFound.bootstrapHide();
        }
        // Load data for the selected domain
        await loadDomainSearchResults(domain, apiToken);
    }
    // Helper function to update domain summary statistics
    function updateDomainSummaryStats(domain) {
        // Find the row in the domains table for this domain to get the stats
        const elementSearch = document.queryHtmlElements(`tr[data-domain="${domain}"]`);
        if (elementSearch.length === 1) {
            const domainRow = elementSearch[0];
            // Get the stats elements
            const totalBreachedEl = document.getHtmlElementById("totalBreachedAddresses");
            const nonSpamBreachedEl = document.getHtmlElementById("nonSpamBreachedAddresses");
            const stealerLogEl = document.getHtmlElementById("stealerLogAddresses");
            if (totalBreachedEl) {
                const raw = domainRow.dataset.pwnCount;
                const num = raw !== undefined ? Number(raw) : Number.NaN;
                totalBreachedEl.textContent = !Number.isNaN(num) ? num.toLocaleString() : "-";
            }
            if (nonSpamBreachedEl) {
                const raw = domainRow.dataset.pwnCountNonSpam;
                const num = raw !== undefined ? Number(raw) : Number.NaN;
                if (!Number.isNaN(num)) {
                    nonSpamBreachedEl.textContent = num.toLocaleString();
                    thisDomainSize = num;
                }
                else {
                    thisDomainSize = 0;
                    nonSpamBreachedEl.textContent = "-";
                }
            }
            if (stealerLogEl) {
                const raw = domainRow.dataset.stealerCount;
                const num = raw !== undefined ? Number(raw) : Number.NaN;
                stealerLogEl.textContent = !Number.isNaN(num) ? num.toLocaleString() : "-";
            }
        }
    }
    // Function to hide domain search results with animation
    function hideDomainSearchResults() {
        // First fade out search view
        if (domainSearchView) {
            domainSearchView.style.opacity = "0";
        }
        // After short delay, hide search view and show domain list
        setTimeout(() => {
            // Hide search view and show domain list
            if (domainListView) {
                domainListView.classList.remove("slide-left");
            }
            if (domainSearchView) {
                domainSearchView.classList.remove("slide-left");
            }
            // Fade in domain list
            setTimeout(() => {
                if (domainListView) {
                    domainListView.style.opacity = "1";
                }
            }, 50);
        }, 300);
    }
    // Global variables to store the full dataset and current view state
    let allEmailData;
    let unfilteredEmailData;
    let filteredEmailData;
    let currentFilter = "";
    // Function to load search results
    async function loadDomainSearchResults(domain, apiToken) {
        const downloadJsonButton = document.getHtmlElementById("domainSearchJsonBtn");
        if (downloadJsonButton?.dataset.downloadLink) {
            const response = await fetch(downloadJsonButton.dataset.downloadLink?.replace("**DOMAIN**", encodeURIComponent(domain)), {
                credentials: "include",
                headers: { "hibp-dashboard-request": "1" },
            });
            if (!response.ok) {
                showReturnNotification("danger", `Failed to load domain search results - ${response.status} - ${response.statusText}`);
            }
            allEmailData = (await response.json());
            // Initialize with all data
            unfilteredEmailData = Object.keys(allEmailData.Breaches).map((alias) => {
                let breaches = allEmailData.Breaches[alias];
                // If breaches is an array of strings, convert it to an array of DomainDescription
                if (Array.isArray(breaches) && breaches.every((b) => typeof b === "string")) {
                    breaches = breaches.map((b) => ({ Name: b, Title: b }));
                }
                return { alias, breaches };
            });
            filteredEmailData = unfilteredEmailData;
            // Update the result count
            updateResultCount();
            // Display all results
            displayAllResults();
            if (domainLoading) {
                domainLoading.bootstrapHide();
            }
        }
        return 1;
    }
    // Function to display all results
    function displayAllResults() {
        // Clear previous results
        if (domainSearchResults) {
            domainSearchResults.innerHTML = "";
        }
        // Update the result count
        updateResultCount();
        // Display all the data
        let i = 1;
        for (const item of filteredEmailData) {
            if (i++ > 10000) {
                // Limit to 10,000 results to prevent performance issues
                break;
            }
            const row = document.createElement("tr");
            row.className = "domain-search-result-item";
            row.innerHTML = `
            <td>${item.alias}@</td>
            <td>${item.breaches.map((breach) => `<a href="/Breach/${breach.Name}" rel="noopener noreferrer">${breach.Title}</a>`).join(", ")}</td>
            <td class="text-end d-none d-sm-table-cell">${item.breaches.length}</td>
          `;
            if (domainSearchResults) {
                domainSearchResults.appendChild(row);
            }
        }
        if (domainSearchResultsFound && noBreachedAddressesOnDomain) {
            if (filteredEmailData.length > 0) {
                domainSearchResultsFound.bootstrapShow();
                noBreachedAddressesOnDomain.bootstrapHide();
            }
            else if (noBreachedAddressesOnDomain) {
                noBreachedAddressesOnDomain.bootstrapShow();
            }
        }
        // Decide if the insufficient subscription warning should be shown
        if (insufficientSubscriptionWarning) {
            const num = maxDomainSize !== undefined ? Number(maxDomainSize) : Number.NaN;
            if (!Number.isNaN(num)) {
                // There is a max domain size, check the results are within this
                if (thisDomainSize > num) {
                    insufficientSubscriptionWarning.bootstrapShow();
                }
            }
        }
    }
    // Helper function to update the result count display
    function updateResultCount() {
        const countElement = document.getHtmlElementById("domainSearchResultCount");
        if (countElement) {
            countElement.textContent = filteredEmailData.length.toLocaleString();
        }
        const countDescriptionElement = document.getHtmlElementById("domainSearchResultDeescription");
        if (countDescriptionElement) {
            let countDescription = "breached address";
            if (filteredEmailData.length > 1) {
                countDescription += "es";
            }
            if (filteredEmailData.length > 10000) {
                countDescription = ". Showing first 10,000 results.";
            }
            countDescriptionElement.textContent = countDescription;
        }
        // If we've filtered and no results are found, hide the table
        if (domainSearchTable) {
            if (filteredEmailData.length === 0) {
                domainSearchTable.bootstrapHide();
            }
            else {
                domainSearchTable.bootstrapShow();
            }
        }
    }
    // Function to filter search results
    function filterDomainSearchResults(query) {
        currentFilter = query.toLowerCase();
        // Filter the full dataset
        if (currentFilter === "") {
            // Reset to all data if filter is empty
            filteredEmailData = unfilteredEmailData;
        }
        else {
            filteredEmailData = unfilteredEmailData.filter((alias) => {
                // Only filter by email alias now
                if (alias.alias.toLowerCase().includes(currentFilter)) {
                    return alias;
                }
            });
        }
        // Update the result count
        updateResultCount();
        // Show all results
        displayAllResults();
    }
    // Function to filter search results
    function sortDomainSearchResults(filterValue) {
        // First, reset to all filtered data based on the text search filter
        if (currentFilter === "") {
            // Reset to all data if filter is empty
            filteredEmailData = unfilteredEmailData;
        }
        else {
            filteredEmailData = unfilteredEmailData.filter((alias) => {
                // Only filter by email alias now
                if (alias.alias.toLowerCase().includes(currentFilter)) {
                    return alias;
                }
            });
        }
        // Then apply the breach filter if not showing all
        if (filterValue !== "all") {
            // Filter to only show emails affected by the recent breach
            filteredEmailData = filteredEmailData.filter((item) => item.breaches.map((item) => item.Title).includes(filterValue));
        }
        // Update the result count
        updateResultCount();
        // Display all results
        displayAllResults();
    }
}
function setupDomainRemoval() {
    const removeButtons = document.queryHtmlElements(".remove-domain");
    const confirmRemovalButton = document.getHtmlElementById("confirmDomainRemoval");
    let domainToRemove = null;
    for (const button of removeButtons) {
        button.addEventListener("click", function () {
            domainToRemove = this.getAttribute("data-domain");
        });
    }
    if (confirmRemovalButton) {
        confirmRemovalButton.addEventListener("click", async () => {
            if (domainToRemove) {
                try {
                    const response = await fetch(`/Dashboard/domain/${encodeURIComponent(domainToRemove)}`, { method: "DELETE" });
                    if (response.status !== 200) {
                        showReturnNotification("danger", `Failed to remove domain ${domainToRemove}. Response: ${response.status} - ${response.statusText}`);
                    }
                    else {
                        // Reset domainToRemove
                        domainToRemove = null;
                        // Reload the window to see the changes
                        window.location.reload();
                    }
                }
                catch (error) {
                    if (error instanceof Error) {
                        showReturnNotification("danger", `Failed to remove domain ${domainToRemove}. Error: ${error.message}`);
                    }
                    else {
                        showReturnNotification("danger", `Failed to remove domain ${domainToRemove}. Error: ${error}`);
                    }
                }
            }
        });
    }
}
